import { Link } from 'react-router-dom';

export default function ContactBox({ 
  title = "Har du brug for hjælp til en opgave?", 
  subtitle = "Kontakt os i dag for en uforpligtende snak om dit projekt.",
  compact = false 
}) {
  if (compact) {
    return (
      <div className="bg-stone-900 rounded-2xl p-6 md:p-10 text-white relative overflow-hidden border border-stone-800 shadow-xl">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-orange-600/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-stone-800/50 rounded-full translate-y-1/2 -translate-x-1/2 blur-2xl" />

        <div className="relative z-10 flex flex-col xl:flex-row xl:items-center justify-between gap-8">
          <div className="max-w-xl space-y-6">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-white tracking-tight leading-tight mb-3">
                {title}
              </h3>
              <p className="text-stone-400 text-sm md:text-base leading-relaxed">
                {subtitle}
              </p>
            </div>

            <div className="flex flex-wrap gap-x-8 gap-y-4 border-t border-stone-800/80 pt-6">
              <a href="tel:+4522458567" className="flex items-center gap-3 text-stone-300 hover:text-orange-500 transition-colors group">
                <div className="w-10 h-10 bg-stone-800 rounded-xl flex items-center justify-center text-orange-500 group-hover:bg-orange-600 group-hover:text-white transition-all duration-300">
                  <i className="fa-solid fa-phone text-sm" />
                </div>
                <div>
                  <span className="text-[10px] text-stone-500 block uppercase tracking-wider font-bold">Ring direkte</span>
                  <span className="font-bold text-sm md:text-base">22 45 85 67</span>
                </div>
              </a>
              <a href="mailto:jan@janhedegaard.dk" className="flex items-center gap-3 text-stone-300 hover:text-orange-500 transition-colors group">
                <div className="w-10 h-10 bg-stone-800 rounded-xl flex items-center justify-center text-orange-500 group-hover:bg-orange-600 group-hover:text-white transition-all duration-300">
                  <i className="fa-solid fa-envelope text-sm" />
                </div>
                <div>
                  <span className="text-[10px] text-stone-500 block uppercase tracking-wider font-bold">Send en mail</span>
                  <span className="font-bold text-sm md:text-base">jan@janhedegaard.dk</span>
                </div>
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-3 shrink-0 w-full xl:w-auto">
            <Link
              to="/kontakt"
              className="bg-orange-600 text-white px-6 py-3.5 rounded-xl text-base font-bold hover:bg-orange-700 transition-all shadow-lg shadow-orange-900/20 flex items-center justify-center gap-2 w-full xl:w-56 group"
            >
              Få et tilbud
              <i className="fa-solid fa-arrow-right text-xs transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/om-os"
              className="bg-white/5 hover:bg-white/10 text-white border border-white/10 px-6 py-3.5 rounded-xl text-base font-bold transition-all flex items-center justify-center w-full xl:w-56"
            >
              Læs om os
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-stone-900 rounded-3xl p-8 md:p-12 lg:p-16 text-white relative overflow-hidden shadow-2xl border border-stone-800">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-orange-600/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-stone-800/50 rounded-full translate-y-1/2 -translate-x-1/2 blur-2xl" />

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 space-y-8">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 tracking-tight leading-tight">{title}</h2>
            <p className="text-stone-400 text-base md:text-lg leading-relaxed">
              {subtitle}
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 border-t border-stone-800/80 pt-8">
            <a href="tel:+4522458567" className="flex items-center gap-4 text-stone-300 hover:text-orange-500 transition-colors group">
              <div className="w-12 h-12 bg-stone-800 rounded-2xl flex items-center justify-center text-orange-500 group-hover:bg-orange-600 group-hover:text-white transition-all duration-300">
                <i className="fa-solid fa-phone text-lg" />
              </div>
              <div>
                <p className="text-xs text-stone-500 uppercase tracking-widest font-bold">Ring direkte</p>
                <p className="text-lg md:text-xl font-bold">22 45 85 67</p>
              </div>
            </a>
            <a href="mailto:jan@janhedegaard.dk" className="flex items-center gap-4 text-stone-300 hover:text-orange-500 transition-colors group">
              <div className="w-12 h-12 bg-stone-800 rounded-2xl flex items-center justify-center text-orange-500 group-hover:bg-orange-600 group-hover:text-white transition-all duration-300">
                <i className="fa-solid fa-envelope text-lg" />
              </div>
              <div>
                <p className="text-xs text-stone-500 uppercase tracking-widest font-bold">Send en mail</p>
                <p className="text-lg md:text-xl font-bold">jan@janhedegaard.dk</p>
              </div>
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 flex flex-col gap-4 lg:items-end w-full">
          <Link
            to="/kontakt"
            className="bg-orange-600 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-orange-700 transition-all shadow-xl shadow-orange-900/40 flex items-center justify-center gap-2 w-full sm:w-64 group"
          >
            Få et tilbud
            <i className="fa-solid fa-arrow-right text-sm transition-transform group-hover:translate-x-1" />
          </Link>
          <Link
            to="/om-os"
            className="bg-white/5 hover:bg-white/10 text-white border border-white/10 px-8 py-4 rounded-xl text-lg font-bold transition-all flex items-center justify-center w-full sm:w-64"
          >
            Læs om os
          </Link>
        </div>
      </div>
    </div>
  );
}
